@use '@/styles/mastodon/mixins';

.root {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  margin-top: var(--space-4);
  color: var(--color-text-secondary);

  @include mixins.type-caption;

  a {
    color: inherit;
    text-decoration: underline;

    &[aria-current='page'] {
      color: var(--color-text-primary);
      text-decoration: none;
    }

    &:hover,
    &:focus,
    &:active {
      text-decoration: none;
    }
  }
}

.list {
  display: flex;
  flex-wrap: wrap;
  align-items: baseline;
  gap: var(--space-2);
}
